import { useQuery } from '@tanstack/react-query'
import { fetchDoctors, type DoctorQuery } from '@/services/httpServices/doctorService'

/** TanStack Query hook for the public doctor directory. */
export function useDoctors(params: DoctorQuery = {}) {
  return useQuery({
    queryKey: ['doctors', params],
    queryFn: () => fetchDoctors(params),
    staleTime: 5 * 60 * 1000,
  })
}
